import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../utils/lazyImportRouteComponent"

export const Route = createFileRoute("/app/outbox")({
  component: lazyImportRouteComponent(
    () => import("./-components/OutboxPage"),
    "OutboxPage"
  ),
  validateSearch: (search: { retry: boolean }) => search,
})
